export enum DataLevel {
    None = 0,       //NO COLOR
    VeryLow = 10,   //GREY
    Low = 20,       //BLUE
    Normal = 30,    //GREEN
    Hight = 40,     //ORANGE
    VeryHight = 50  //RED
}
